export default __webpack_public_path__ + "static/media/insta.a772394b.svg";